import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import { AlignBox } from "../Align";
import Badge from "../Badge";
import Box from "../Box";
import { FormContext } from "./";
import Group from "../Group";
import { Text } from "../Text";
import { FormBlockContext } from "./FormBlock";

var FormRow = function FormRow(props) {
  var getDivider = function getDivider(rowDividers) {
    var divider = props.divider;
    var dividerValue = {
      color: 'light',
      side: 'bottom',
      width: 1
    };

    if (divider === false) {
      return null;
    } else if (divider === true || rowDividers === true) {
      return dividerValue;
    } else if (rowDividers === false) {
      return null;
    }
  };

  var getAlign = function getAlign(layout) {
    return layout === 'inline' ? 'flex-start' : 'stretch';
  };

  var getDirection = function getDirection(layout) {
    return layout === 'inline' ? 'row' : 'column';
  };

  var getPadding = function getPadding(layout, size) {
    if (size === 'small' && layout === 'inline') {
      return {
        right: 12,
        vertical: 2
      };
    } else if (layout === 'inline') {
      return {
        right: 12,
        vertical: 4
      };
    }

    return {
      bottom: 8
    };
  };

  var getTextProps = function getTextProps(size) {
    return {
      lineHeight: size === 'jumbo' ? 24 : 20,
      size: size === 'jumbo' ? 16 : 14
    };
  };

  var className = props.className,
      children = props.children,
      description = props.description,
      divider = props.divider,
      label = props.label,
      name = props.name,
      tag = props.tag,
      remaining = _objectWithoutProperties(props, ["className", "children", "description", "divider", "label", "name", "tag"]);

  return /*#__PURE__*/React.createElement(FormContext.Consumer, null, function (_ref) {
    var layout = _ref.layout,
        size = _ref.size;
    return /*#__PURE__*/React.createElement(FormBlockContext.Consumer, null, function (_ref2) {
      var rowDividers = _ref2.rowDividers;
      var classes = classNames('FormRow', {
        'FormRow--layout--inline': layout === 'inline',
        'FormRow--layout--stacked': layout === 'stacked',
        'FormRow--hasName': name
      }, className);
      var hasCopy = label || description;
      var startFlexProps = layout === 'inline' ? {
        flexBasis: '25%',
        flexGrow: 1,
        flexShrink: 0
      } : null;
      var endFlexProps = layout === 'inline' ? {
        flexBasis: '75%',
        flexGrow: 1,
        flexShrink: 1
      } : null;
      return /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
        className: classes,
        divider: getDivider(rowDividers),
        flex: {
          alignItems: getAlign(layout),
          direction: getDirection(layout)
        },
        padding: rowDividers ? 20 : {
          horizontal: 20,
          vertical: 16
        }
      }), hasCopy && /*#__PURE__*/React.createElement(Box, _extends({
        className: "FormRow-start"
      }, startFlexProps, {
        padding: getPadding(layout, size)
      }), label && /*#__PURE__*/React.createElement(Box, {
        flex: true
      }, /*#__PURE__*/React.createElement(Box, {
        padding: tag ? {
          right: 8
        } : {}
      }, /*#__PURE__*/React.createElement(Text, _extends({}, getTextProps(size), {
        color: "dark",
        weight: "medium"
      }), /*#__PURE__*/React.createElement("label", {
        className: "FormRow-label",
        htmlFor: name
      }, label))), tag && /*#__PURE__*/React.createElement(AlignBox, {
        reference: getTextProps(size)
      }, /*#__PURE__*/React.createElement(Badge, {
        variant: "tag",
        label: tag
      }))), description && /*#__PURE__*/React.createElement(Text, _extends({}, getTextProps(size), {
        color: "default",
        weight: "regular"
      }), description)), /*#__PURE__*/React.createElement(Box, endFlexProps, /*#__PURE__*/React.createElement(Group, {
        className: "FormRow-end",
        spacing: 16
      }, children)));
    });
  });
};

export default FormRow;